import { useCallback, useEffect, useState } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import axios from "../../../axios";
import * as S from "../Funnel/Funnel.styled";
import TeacherBroadcasts from "./TeacherBroadcasts";

// Розсилки через шкільного Telegram-бота (@speaksy_en_bot). Зручно з телефона: шаблон → правка → «собі» → усім.
// Вкладка «Вчителям» — оголошення через бот вчителів (TeacherBroadcasts).
const plain = (html) => String(html || "").replace(/<[^>]+>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&amp;/g, "&");
// Чат з учнем за номером із картки: Telegram (t.me/+380…) і Viber; @нік — одразу в Telegram
const chatLinks = (phone) => {
  const nick = String(phone || "").trim().match(/^(?:@|(?:https?:\/\/)?t\.me\/)([a-z0-9_]{4,})$/i);
  if (nick) return { tg: `https://t.me/${nick[1]}` };
  let d = String(phone || "").replace(/\D/g, "");
  if (d.length === 10 && d.startsWith("0")) d = "38" + d;
  if (d.length < 10) return {};
  return { tg: `https://t.me/+${d}`, viber: `viber://chat?number=%2B${d}` };
};
const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch { window.prompt("Скопіюйте повідомлення:", text); return false; }
};
const when = (d) => (d ? new Date(d).toLocaleString("uk-UA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

function Broadcasts() {
  const [tab, setTab] = useState("students");
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [text, setText] = useState("");
  const [segment, setSegment] = useState("all");
  const [promo, setPromo] = useState(true);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState("");
  const [invites, setInvites] = useState(null);
  const [copied, setCopied] = useState("");

  const load = useCallback(() => {
    axios.get("admin/bot").then((r) => setInfo(r.data)).catch(() => setError("Не вдалося завантажити дані бота"));
    axios.get("admin/bot/invites").then((r) => setInvites(r.data)).catch(() => setInvites([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const linkMyTelegram = async () => {
    const { data } = await axios.post("admin/bot/link", { kind: "admin" });
    window.open(data.url, "_blank", "noopener");
  };
  const copyInvite = async (st) => {
    const { data } = await axios.post(`admin/bot/invites/${st._id}`);
    await copyText(data.text);
    setCopied(st._id);
    setInvites((list) => list.map((x) => (x._id === st._id ? { ...x, inviteAt: new Date().toISOString() } : x)));
  };
  const applyTemplate = (t) => { setText(t.text); setPromo(t.promo); setResult(""); };
  // Акцію не отримають ті, хто вимкнув акції, — рахуємо саме тих, кому піде
  const recipients = (key) => (promo ? info?.segments?.[key]?.promoChats : info?.segments?.[key]?.chats) ?? 0;
  const describe = (d) => [
    `доставлено ${d.delivered} з ${d.total}`,
    d.blocked ? `заблокували бота: ${d.blocked}` : "",
    d.failed ? `не надіслано: ${d.failed}${d.error ? ` (${d.error})` : ""}` : "",
  ].filter(Boolean).join(" · ");
  const send = async (test) => {
    if (!text.trim()) return setResult("Напишіть повідомлення");
    const count = recipients(segment);
    if (!test && !window.confirm(`Надіслати повідомлення ${count} отримувачам («${info.segments[segment].label}»)?`)) return;
    setBusy(true); setResult("");
    try {
      const { data } = await axios.post("admin/bot/broadcast", { segment, text, promo, test });
      const ok = data.delivered > 0 && !data.failed;
      setResult(test
        ? (ok ? "✅ Надіслано вам у Telegram — перевірте, як виглядає." : `⚠️ Не дійшло: ${describe(data)}`)
        : `${ok ? "✅" : "⚠️"} ${describe(data)}`);
      load();
    } catch (e) {
      setResult("⚠️ " + (e?.response?.data?.message || "Не вдалося надіслати"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PagesWrapper>
      <TopPageTitle value={"Розсилки"} />
      <S.Page>
        <S.Chips>
          <S.Chip type="button" $on={tab === "students"} onClick={() => setTab("students")}>Учням</S.Chip>
          <S.Chip type="button" $on={tab === "teachers"} onClick={() => setTab("teachers")}>Вчителям</S.Chip>
        </S.Chips>
        {tab === "teachers" && <TeacherBroadcasts />}
        {tab === "students" && error && <S.ErrorText>{error}</S.ErrorText>}
        {tab === "students" && info && !info.enabled && <S.Card><S.Empty>Бот ще не підключений на сервері.</S.Empty></S.Card>}
        {tab === "students" && info?.enabled && (
          <>
            <S.Card>
              <S.CardHead>
                <div>
                  <S.H>Telegram-бот @{info.username}</S.H>
                  <S.Hint>Учнів у боті: <b>{info.linkedStudents}</b> · пробних отримали доступ через бот: <b>{info.trialsDelivered}</b></S.Hint>
                </div>
                {!info.adminLinked
                  ? <S.Btn onClick={linkMyTelegram}>Підключити свій Telegram для перевірки</S.Btn>
                  : <S.Tag $c="green">ваш Telegram підключено</S.Tag>}
              </S.CardHead>

              <S.Small style={{ fontWeight: 700, marginBottom: 6 }}>Готові шаблони (можна редагувати)</S.Small>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                {info.templates.map((t) => <S.Btn key={t.id} $ghost onClick={() => applyTemplate(t)}>{t.title}</S.Btn>)}
              </div>

              <textarea
                value={text}
                onChange={(e) => { setText(e.target.value); setResult(""); }}
                placeholder="Текст повідомлення. Жирний: <b>текст</b>"
                rows={7}
                style={{ width: "100%", boxSizing: "border-box", font: "inherit", padding: 12, borderRadius: 10, border: "1px solid #dcd7ee", resize: "vertical" }}
              />
              <S.Hint style={{ textAlign: "right", marginTop: 4 }}>{text.length} / 3500</S.Hint>

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", margin: "10px 0" }}>
                <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: "0.85rem", fontWeight: 700 }}>
                  Кому
                  <S.Select value={segment} onChange={(e) => setSegment(e.target.value)}>
                    {Object.entries(info.segments).map(([k, v]) => <option key={k} value={k}>{v.label} — {recipients(k)}</option>)}
                  </S.Select>
                </label>
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: "0.9rem", cursor: "pointer" }}>
                  <input type="checkbox" checked={promo} onChange={(e) => setPromo(e.target.checked)} style={{ width: 18, height: 18, appearance: "auto", WebkitAppearance: "checkbox", opacity: 1, position: "static", accentColor: "#6c5ce7", flex: "none" }} />
                  Це акція (не надсилати тим, хто вимкнув акції)
                </label>
              </div>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <S.Btn $ghost disabled={busy || !info.adminLinked} onClick={() => send(true)}>Надіслати собі на перевірку</S.Btn>
                <S.Btn disabled={busy || recipients(segment) === 0} onClick={() => send(false)}>{busy ? "Надсилаю…" : `Надіслати (${recipients(segment)})`}</S.Btn>
              </div>
              {result && <S.Hint style={{ marginTop: 10, fontWeight: 700 }}>{result}</S.Hint>}
              {!info.adminLinked && <S.Hint style={{ marginTop: 6 }}>Щоб надсилати собі на перевірку, спершу підключіть свій Telegram кнопкою вгорі.</S.Hint>}
            </S.Card>

            {invites?.length > 0 && (
              <S.Card>
                <S.CardHead>
                  <div>
                    <S.H>Ще не підключили бота — {invites.length}</S.H>
                    <S.Hint>«📋 Повідомлення» копіює текст з особистим посиланням → «Telegram» / «Viber» відкриває чат з учнем → вставити й надіслати. Хто підключиться — зникне зі списку.</S.Hint>
                  </div>
                  <S.Tag>скопійовано: {invites.filter((x) => x.inviteAt).length} з {invites.length}</S.Tag>
                </S.CardHead>
                <S.List style={{ maxHeight: 480, overflowY: "auto" }}>
                  {invites.map((st) => {
                    const links = chatLinks(st.phone);
                    return (
                      <li key={st._id} style={{ alignItems: "center", flexWrap: "wrap" }}>
                        <span><b>{st.name}</b> <S.Hint as="span" style={{ margin: 0 }}>ID {st.studentId} · {st.phone || "без телефону"}</S.Hint></span>
                        <span style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end" }}>
                          {st.inviteAt && <S.Tag $c="green">{copied === st._id ? "✅ скопійовано" : `скопійовано ${when(st.inviteAt)}`}</S.Tag>}
                          <S.Btn $ghost onClick={() => copyInvite(st)}>📋 Повідомлення</S.Btn>
                          {links.tg && <S.Btn $ghost as="a" href={links.tg} target="_blank" rel="noopener noreferrer">Telegram</S.Btn>}
                          {links.viber && <S.Btn $ghost as="a" href={links.viber}>Viber</S.Btn>}
                        </span>
                      </li>
                    );
                  })}
                </S.List>
              </S.Card>
            )}

            <S.Card>
              <S.CardHead>
                <div>
                  <S.H>Підключили бота — {info.linkedList?.length ?? info.linkedStudents}</S.H>
                  <S.Hint>Нові зверху. «заблокував» — розсилки до нього не дійдуть.</S.Hint>
                </div>
              </S.CardHead>
              {!info.linkedList?.length ? <S.Empty>Поки ніхто не підключив</S.Empty> : (
                <S.List style={{ maxHeight: 420, overflowY: "auto" }}>
                  {info.linkedList.map((s) => (
                    <li key={s._id}>
                      <span><b>{s.name}</b> <S.Hint as="span" style={{ margin: 0 }}>ID {s.studentId} · {when(s.linkedAt)}{s.chats > 1 ? ` · Telegram: ${s.chats}` : ""}</S.Hint></span>
                      <span style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
                        {s.isTest && <S.Tag $c="pink">тест</S.Tag>}
                        {s.isPaused && <S.Tag>на паузі</S.Tag>}
                        {s.blocked ? <S.Tag $c="red">заблокував</S.Tag> : s.promoOff ? <S.Tag $c="amber">без акцій</S.Tag> : <S.Tag $c="green">активний</S.Tag>}
                      </span>
                    </li>
                  ))}
                </S.List>
              )}
            </S.Card>

            <S.Card>
              <S.CardHead><S.H>Історія розсилок</S.H></S.CardHead>
              {info.history.length === 0 ? <S.Empty>Ще не було розсилок</S.Empty> : (
                <S.List>
                  {info.history.map((h) => (
                    <li key={h._id}>
                      <span>{when(h.createdAt)} · <b>{h.test ? "перевірка" : info.segments[h.segment]?.label || h.segment}</b>
                        <S.Hint style={{ margin: 0 }}>{plain(h.text).slice(0, 90)}{plain(h.text).length > 90 ? "…" : ""}</S.Hint>
                        {h.error && <S.Hint style={{ margin: 0, color: "#c0392b" }}>Не дійшло: {h.error}</S.Hint>}
                      </span>
                      <S.Tag $c={h.failed || h.blocked ? "amber" : "green"}>{h.delivered}/{h.total}</S.Tag>
                    </li>
                  ))}
                </S.List>
              )}
            </S.Card>
          </>
        )}
      </S.Page>
    </PagesWrapper>
  );
}

export default Broadcasts;
